(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      // El buscador se eliminó del header: puede no existir ningún details-modal.
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regis-newsletter-popup"]) return;
  try {
    
    class RegisPopup extends HTMLElement {
      constructor() {
        super();
        this.key = this.dataset.storageKey;
        this.dialog = this.querySelector('.regis-popup__dialog');
        this.lastFocus = null;
      }

      connectedCallback() {
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-popup-close]')) this.close();
        });
        this.onKeydown = (e) => { if (e.key === 'Escape') this.close(); };

        // Suscripción correcta: la página recarga con #<id del formulario> y el
        // snippet pinta .regis-nl__success + el código. Abrir YA para que lo vea,
        // salvo que se haya suscrito desde otro formulario de la página.
        if (this.querySelector('.regis-nl__success')) {
          this.markSubscribed();
          const form = this.querySelector('form');
          const hash = window.location.hash;
          if (!hash || (form && hash === '#' + form.id)) this.open();
          return;
        }
        if (this.isSubscribed() || this.isDismissed()) return;

        const delay = (parseInt(this.dataset.delay, 10) || 0) * 1000;
        this.timer = setTimeout(() => this.open(), delay);
      }

      isSubscribed() {
        try {
          return localStorage.getItem('regis-nl-subscribed') === '1';
        } catch (e) { return false; }
      }

      markSubscribed() {
        try {
          localStorage.setItem('regis-nl-subscribed', '1');
        } catch (e) { /* localStorage no disponible */ }
      }

      isDismissed() {
        try {
          const until = localStorage.getItem(this.key);
          return until && Date.now() < parseInt(until, 10);
        } catch (e) { return false; }
      }

      remember() {
        try {
          const days = parseInt(this.dataset.days, 10) || 30;
          localStorage.setItem(this.key, Date.now() + days * 86400000);
        } catch (e) { /* localStorage no disponible */ }
      }

      open() {
        this.classList.add('is-open');
        this.lastFocus = document.activeElement;
        document.addEventListener('keydown', this.onKeydown);
        if (this.dialog) this.dialog.focus();
      }

      close() {
        clearTimeout(this.timer);
        this.classList.remove('is-open');
        document.removeEventListener('keydown', this.onKeydown);
        this.remember();
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      }
    }
    if (!customElements.get('regis-popup')) {
      customElements.define('regis-popup', RegisPopup);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regis-product-main"]) return;
  try {
    
  /* Galería ligera: cambia la imagen principal y abre lightbox de zoom */
  if (!customElements.get('regis-product-gallery')) {
    customElements.define('regis-product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.mainImg = this.querySelector('.regis-gallery__main-img');
        this.thumbs = Array.from(this.querySelectorAll('.regis-gallery__thumb'));
        this.lightbox = this.querySelector('.regis-gallery__lightbox');
        this.zoomEnabled = this.dataset.zoom === 'true';

        // Cuando la imagen nueva termina de cargar, hacemos el fade-in.
        if (this.mainImg) {
          this.mainImg.addEventListener('load', () => { this.mainImg.style.opacity = '1'; });
        }

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.select(thumb));
        });

        if (this.zoomEnabled && this.lightbox) {
          const hint = this.querySelector('.regis-gallery__zoom-hint');
          const closeBtn = this.querySelector('.regis-gallery__lightbox-close');
          const lbImg = this.lightbox.querySelector('.regis-gallery__lightbox-img');
          const open = () => {
            if (!this.mainImg) return;
            lbImg.src = this.mainImg.currentSrc || this.mainImg.src;
            if (typeof this.lightbox.showModal === 'function') this.lightbox.showModal();
          };
          hint && hint.addEventListener('click', open);
          this.mainImg && this.mainImg.addEventListener('click', open);
          closeBtn && closeBtn.addEventListener('click', () => this.lightbox.close());
          this.lightbox.addEventListener('click', (e) => { if (e.target === this.lightbox) this.lightbox.close(); });
        }
      }
      select(thumb) {
        const img = this.mainImg;
        if (!img || !thumb.dataset.full) return;
        if (img.dataset.current === thumb.dataset.full) return;

        this.thumbs.forEach((t) => {
          t.classList.remove('is-active');
          t.setAttribute('aria-current', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');

        // Respeta "reduce motion": cambio instantáneo, sin fundido ni parpadeo.
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          img.dataset.current = thumb.dataset.full;
          img.src = thumb.dataset.full;
          if (thumb.dataset.fullSrcset) img.srcset = thumb.dataset.fullSrcset;
          img.style.opacity = '1';
          return;
        }

        // Crossfade: fundido de salida → cambio de src → fundido de entrada al cargar.
        clearTimeout(this._swapT);
        clearTimeout(this._failT);
        img.style.opacity = '0';
        this._swapT = setTimeout(() => {
          img.dataset.current = thumb.dataset.full;
          img.src = thumb.dataset.full;
          if (thumb.dataset.fullSrcset) img.srcset = thumb.dataset.fullSrcset;
          // Red de seguridad si el evento load no llega (imagen en caché).
          this._failT = setTimeout(() => { img.style.opacity = '1'; }, 400);
        }, 200);
      }
    });
  }

  /* Precio: al cambiar de pack, actualiza el precio al instante (fiable, sin
     depender del re-render) y sincroniza el id de variante para el carrito y
     apps de suscripción (Seal). */
  document.addEventListener('change', function (e) {
    var radio = e.target && e.target.closest ? e.target.closest('.regis-formats__radio') : null;
    if (!radio) return;
    var info = radio.closest('product-info');
    if (!info) return;
    var vid = radio.dataset.variantId;
    var priceEl = document.getElementById('price-' + info.dataset.section);
    var mapEl = info.querySelector('[data-regis-price-map]');
    if (priceEl && mapEl && vid) {
      try {
        var map = JSON.parse(mapEl.textContent);
        if (map[vid]) priceEl.innerHTML = map[vid];
      } catch (err) {}
    }
    if (vid) {
      info.querySelectorAll('input[name="id"]').forEach(function (input) {
        if (input.value !== vid) {
          input.value = vid;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
